import { Component, OnInit } from '@angular/core';
import { BadgeModule } from 'primeng/badge';
import { MenuItem } from 'primeng/api';
import { PanelMenuModule } from 'primeng/panelmenu';
import { RouterModule } from '@angular/router';
import { environment } from '../../../environments/environment';
import { routesPath } from '../../core/constants/app.constants';

@Component({
    selector: 'app-sidebar',
    imports: [RouterModule, PanelMenuModule, BadgeModule],
    standalone: true,
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.css'
})
export class SidebarComponent implements OnInit {

    itemsMenu: MenuItem[] | undefined;

    ngOnInit() {

        //Menu de administracion
        var itemAdministracion: MenuItem = {
            label: 'Administracion',
            icon: 'pi pi-file',
            items: []
        };

        const itemClientes: MenuItem = {
            label: 'Clientes',
            icon: 'pi pi-file-edit',
            routerLink: '/' + routesPath.clientes.base + '/' + routesPath.clientes.listar
        };

        if (environment.appFrontend.modules.administracion.modules.clientes.active) {
            itemAdministracion.items!.push(itemClientes);
        }

        const itemContactos: MenuItem = {
            label: 'Contactos',
            icon: 'pi pi-file',
            routerLink: '/' + routesPath.contactos.base + '/' + routesPath.contactos.listar
        };

        if (environment.appFrontend.modules.administracion.modules.contactos.active) {
            itemAdministracion.items!.push(itemContactos);
        }

        //Hosting
        var itemHosting: MenuItem = {
            label: 'Hosting',
            icon: 'pi pi-server',
            items: []
        };

        const itemCuentas: MenuItem = {
            label: 'Cuentas',
            icon: 'pi pi-warehouse',
            routerLink: '/' + routesPath.hosting.base + '/' + routesPath.hosting.listar
        };

        if (environment.appFrontend.modules.hosting.modules.cuentas.active) {
            itemHosting.items!.push(itemCuentas);
        }

        //Dominios
        var itemDominios: MenuItem = {
            label: 'Dominios',
            icon: 'pi pi-address-book',
            items: []
        };

        const itemContratadosInternacional: MenuItem = {
            label: 'Internacional',
            icon: 'pi pi-file',
            routerLink: '/' + routesPath.dominios.base + '/' + routesPath.dominios.contratados.internacional.listar
        };

        if (environment.appFrontend.modules.dominios.modules.contratados_internacional.active) {
            itemDominios.items!.push(itemContratadosInternacional);
        }

        //Soporte
        var itemSoporte: MenuItem = {
            label: 'Soporte',
            icon: 'pi pi-save',
            items: []
        };

        const itemCallcenter: MenuItem = {
            label: 'Callcenter',
            icon: 'pi pi-file',
            routerLink: '/'
        };

        if (environment.appFrontend.modules.soporte.modules.callcenter.active) {
            itemSoporte.items!.push(itemCallcenter);
        }

        const itemTickets: MenuItem = {
            label: 'Tickets',
            icon: 'pi pi-file',
            routerLink: '/'
        };

        if (environment.appFrontend.modules.soporte.modules.tickets.active) {
            itemSoporte.items!.push(itemTickets);
        }

        //Construir el menu
        this.itemsMenu = [];

        if (environment.appFrontend.modules.administracion.active) {
            this.itemsMenu!.push(itemAdministracion);
        }

        if (environment.appFrontend.modules.hosting.active) {
            this.itemsMenu!.push(itemHosting);
        }

        if (environment.appFrontend.modules.dominios.active) {
            this.itemsMenu!.push(itemDominios);
        }

        if (environment.appFrontend.modules.soporte.active) {
            this.itemsMenu!.push(itemSoporte);
        }
        /*
        this.itemsMenu = [
            {
                label:'Administracion',
                icon : 'pi pi-file',
                items:[
                    {
                        label:'Clientes',
                        icon : 'pi pi-file-edit',
                        routerLink: '/clientes/listar'
                    },
                    {
                        label:'Contactos',
                        icon : 'pi pi-file',
                        routerLink: '/contactos/listar'
                    }
                ]
            },
            {
                label:'Hosting',
                icon : 'pi pi-server',
                items:[
                    {
                        label:'Cuentas',
                        icon : 'pi pi-warehouse',
                        routerLink:'/hosting/listar'
                    }
                ]
            },
            {
                label:'Dominios',
                icon : 'pi pi-address-book',
                items:[
                    {
                        label:'Contratados (Internacional)',
                        icon : 'pi pi-file',
                        routerLink:'/dominios/contratados/internacional/listar'
                    }
                ]
            },
            {
                label:'Soporte',
                icon : 'pi pi-save',
                items:[
                    {
                        label:'Callcenter',
                        icon : 'pi pi-file',
                        routerLink:'/'
                    },
                    {
                        label:'Tickets',
                        icon : 'pi pi-file',
                        routerLink:'/'
                    }
                ]
            }
        ];*/
    }
}